// @ts-nocheck

import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';

import { __ } from '../../i18n/l10n';
import colors from '../../styled-components/palette';
import CollapseListItem from '../CollapseListItem';
import ExpandArrow from '../ExpandArrow/ExpandArrow';
import MultimatchItemContainer from '../MultimatchItem/MultimatchItemContainer';

const MultimatchDetailsTheme = {
  boxBackgroundColor: colors.bluegrey900,
};

const Wrapper = styled.div`
  margin: 0.6em;
  padding: 0.5em 0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  background-color: ${MultimatchDetailsTheme.boxBackgroundColor};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5em;
`;

const DetailsLabel = styled.div`
  display: inline-block;
  font-weight: bold;
  font-size: 105%;
  padding: 0.3em;

  color: white;
`;

const StyledExpandArrow = styled(ExpandArrow)`
  margin: 0.13em;
  height: 0.52em;
  cursor: pointer;

  transition: transform 250ms ease-in-out;

  ${({ $isExpand }) =>
    $isExpand
      ? css`
          transform: rotate(0deg);
        `
      : css`
          transform: rotate(180deg);
        `}
`;

const StyledMultimatchItemContainer = styled(MultimatchItemContainer)`
  &:not(:first-child) {
    border-top: 1px solid ${colors.bluegrey800};
  }
`;

type PropsType = {
  className?: string;
  matchIds: Array<number> | null;
};

const MultimatchDetails = ({ matchIds }: PropsType) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleDetails = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  return (
    <Wrapper>
      <Header onClick={toggleDetails}>
        <DetailsLabel>{__('Match details')}</DetailsLabel>
        <StyledExpandArrow $isExpand={isOpen} />
      </Header>
      <CollapseListItem isOpened={isOpen}>
        {matchIds?.map((matchId) => <StyledMultimatchItemContainer key={matchId} matchId={matchId} />)}
      </CollapseListItem>
    </Wrapper>
  );
};

export default React.memo<PropsType>(MultimatchDetails);
